// @ts-nocheck
import * as R from 'unitx/ramda';
import { getSchemaType, getDefaultFormState as getDefaultFormStateDefault } from "./default";
export const isAnyOfType = schema => R.anyPass([R.has('anyOf'), () => R.isNil(getSchemaType(schema))])(schema);
export const isAnyOfOrObjectType = schema => R.anyPass([R.has('anyOf'), () => R.isNil(getSchemaType(schema)), R.propEq('type', 'object'), R.propEq('type', 'array')])(schema);
export const filterRequiredProperties = (formData, schema) => {
  var _schema$required;

  return R.when(() => R.propEq('type', 'object')(schema), R.pick((_schema$required = schema.required) !== null && _schema$required !== void 0 ? _schema$required : []))(formData);
};
export const filterRequiredPropertiesFromSchema = schema => R.over(R.lensProp('properties'), R.when(() => R.propEq('type', 'object')(schema), R.omitBy((value, key) => {
  var _schema$required2;

  return !((_schema$required2 = schema.required) !== null && _schema$required2 !== void 0 ? _schema$required2 : []).includes(key);
})))(schema); // export const filterRequiredPropertiesWithData = (
//   data: any,
//   schema: any,
// ) => R.over(
//   R.lensProp('properties'),
//   R.when(
//     () => R.propEq('type', 'object')(schema),
//     R.omitBy(
//       (value, key) => (!(schema.required ?? []).includes(key) && R.isNil(data[key])),
//     ),
//   ),
// )(schema)

export const getDefaultFormState = (schema, data, rootSchema, includeUndefinedValues = false) => {
  const currentSchema = schema.anyOf ? schema.anyOf[0] : schema;
  const result = getDefaultFormStateDefault(currentSchema, data, rootSchema, includeUndefinedValues);
  return result; // R.pick(schema.required ?? [])(result)
};
export const getDefaultRegistry = () => ({
  fields: require("../components/Fields"),
  widgets: require("../components/Widgets"),
  definitions: {},
  rootSchema: {},
  formContext: {}
});
export const setUninitializedValue = config => {
  const {
    onChange,
    condition,
    getDefault,
    required
  } = config;
  if (!required && !condition) return;
  setTimeout(() => {
    onChange(getDefault());
  }, 100);
};
export { getWidget, getUiOptions, isMultiSelect, isFilesArray, isFixedItems, isObject, allowAdditionalItems, optionsList, retrieveSchema, toIdSchema // getDefaultRegistry,
, guessType, asNumber, orderProperties, ADDITIONAL_PROPERTY_FLAG, isSelect, mergeObjects, deepEquals, getSchemaType, hasWidget, rangeSpec, shouldRender // dataURItoBlob,
// findSchemaDefinition,
, getMatchingOption // isConstant,
// mergeDefaultsWithFormData,
// mergeSchemas,
// pad,
// parseDateString,
// resolveSchema,
// stubExistingAdditionalProperties,
// toConstant,
// toDateString,
, toPathSchema } from "./default";